'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'wand-magic-sparkles';
var width = 576;
var height = 512;
var aliases = ["magic-wand-sparkles"];
var unicode = 'e2ca';
var svgPathData = 'M123.3 500.7L112 512l-11.3-11.3L43.3 443.3 32 432l11.3-11.3L452.7 11.3 464 0l11.3 11.3 57.4 57.4L544 80 532.7 91.3 123.3 500.7zM521.4 80L464 22.6l-135 135L386.3 215l135-135zM54.6 432L112 489.4l263-263L317.7 169 54.6 432zM104 64l0 56 56 0 8 0 0 16-8 0-56 0 0 56 0 8-16 0 0-8 0-56-56 0-8 0 0-16 8 0 56 0 0-56 0-8 16 0 0 8zM488 312l0 8 0 56 56 0 8 0 0 16-8 0-56 0 0 56 0 8-16 0 0-8 0-56-56 0-8 0 0-16 8 0 56 0 0-56 0-8 16 0zM232 32l0 24 24 0 8 0 0 16-8 0-24 0 0 24 0 8-16 0 0-8 0-24-24 0-8 0 0-16 8 0 24 0 0-24 0-8 16 0 0 8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faWandMagicSparkles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;